export interface PojectSpendingShopType {
    id?: number;
    shop_name?: string;
    status?: 1 | 0;
    created_by?: number;
}

// to single object maping
export const mapShopType = (data: any): PojectSpendingShopType => {
    if (!data) {
        throw new Error('Invalid Shops')
    }
    
    const shop: PojectSpendingShopType = {
        id: data.id,
        shop_name: data.shop_name,
        status: data.status,
        created_by: data.created_by,
    }

    return shop;
}

// maping list objects
export const mapShopTypes = (data: any[]): PojectSpendingShopType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Shops');
    }
    return data.map(mapShopType);
}
